<template>
  <div class="operation-record-container">
    <el-card class="box-card">
      <div class="search-area">
        <el-form ref="queryForm" :model="queryParams" label-width="80px" inline size="small">
          <el-form-item label="运营商:" v-if="isAdmin">
            <el-select v-model="queryParams.distributorId" placeholder="请选择" clearable filterable style="width: 160px;">
              <el-option v-for="item in distributorOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作类型:">
            <el-select v-model="queryParams.operationType" placeholder="请选择" clearable style="width: 130px;">
              <el-option label="开锁" :value="1"></el-option>
              <el-option label="关锁" :value="2"></el-option>
              <el-option label="重启" :value="3"></el-option>
              <el-option label="升级" :value="4"></el-option>
              <el-option label="IP设置" :value="5"></el-option>
              <el-option label="定位" :value="6"></el-option>
              <el-option label="开座舱锁" :value="9"></el-option>
              <el-option label="语音播报" :value="14"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作来源:">
            <el-select v-model="queryParams.operationSource" placeholder="请选择" clearable style="width: 130px;">
              <el-option label="管理后台" :value="1"></el-option>
              <el-option label="运维小程序" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备编号:">
            <el-input v-model="queryParams.qrNumber" placeholder="请输入设备编号" clearable style="width: 160px;" />
          </el-form-item>
          <el-form-item label="操作人员:">
            <el-input v-model="queryParams.operatorName" placeholder="请输入操作人员" clearable style="width: 130px;" />
          </el-form-item>
          <el-form-item label="手机号:">
            <el-input v-model="queryParams.operatorMobile" placeholder="请输入手机号" clearable style="width: 140px;" />
          </el-form-item>
          <el-form-item label="操作时间:">
            <el-date-picker
              v-model="queryParams.dateRange"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 240px;"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="table-container">
        <el-table :data="recordList" border stripe :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }" v-loading="loading">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="qrNumber" label="设备编号" width="120"></el-table-column>
          <el-table-column prop="imei" label="IMEI" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作类型" width="100">
            <template slot-scope="scope">
              <el-tag :type="getOperationTypeTag(scope.row.operationType)" size="small">
                {{ getOperationTypeName(scope.row.operationType) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作来源" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.operationSource === 1 ? 'primary' : 'success'" size="small">
                {{ scope.row.operationSource === 1 ? '管理后台' : '运维小程序' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="operatorName" label="操作人员" width="100"></el-table-column>
          <el-table-column prop="operatorMobile" label="手机号" width="120"></el-table-column>
          <el-table-column prop="distributorName" label="运营商" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="结果" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.result === 1 ? 'success' : 'danger'" size="small">
                {{ scope.row.result === 1 ? '成功' : '失败' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="failReason" label="失败原因" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="operationTime" label="操作时间" width="160"></el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
  name: 'OperationRecord',
  data() {
    return {
      loading: false,
      isAdmin: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        distributorId: '',
        operatorName: '',
        operationType: null,
        operationSource: null,
        qrNumber: '',
        operatorMobile: '',
        dateRange: [],
        queryDistributorId: ''
      },
      distributorOptions: [],
      recordList: []
    }
  },
  created() {
    this.checkAdmin()
    this.getDistributorOptions()
    this.queryParams.queryDistributorId = getCurrentDistributorId()
    this.getList()
    this.$root.$on('distributorChanged', this.handleDistributorChange)
  },
  beforeDestroy() {
    this.$root.$off('distributorChanged', this.handleDistributorChange)
  },
  methods: {
    handleDistributorChange(distributorId) {
      this.queryParams.queryDistributorId = distributorId || ''
      this.queryParams.pageNum = 1
      this.getList()
    },
    checkAdmin() {
      this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true'
    },
    getDistributorOptions() {
      this.$http.get('/distributor/manager/getAllDistributorInfo').then(res => {
        if (res.data.code === 200) {
          this.distributorOptions = res.data.data || []
        }
      })
    },
    getList() {
      this.loading = true
      const params = {
        page: this.queryParams.pageNum,
        limit: this.queryParams.pageSize,
        distributorId: this.queryParams.distributorId,
        operatorName: this.queryParams.operatorName,
        operationType: this.queryParams.operationType,
        operationSource: this.queryParams.operationSource,
        qrNumber: this.queryParams.qrNumber,
        operatorMobile: this.queryParams.operatorMobile,
        startTime: '',
        endTime: '',
        queryDistributorId: this.queryParams.queryDistributorId
      }
      if (this.queryParams.dateRange && this.queryParams.dateRange.length === 2) {
        params.startTime = this.queryParams.dateRange[0]
        params.endTime = this.queryParams.dateRange[1]
      }
      
      this.$http.post('/operationRecord/manager/getPageList', params).then(res => {
        this.loading = false
        if (res.data.code === 200) {
          this.recordList = res.data.data.list || []
          this.total = res.data.data.total || 0
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        distributorId: '',
        operatorName: '',
        operationType: null,
        operationSource: null,
        qrNumber: '',
        operatorMobile: '',
        dateRange: [],
        queryDistributorId: getCurrentDistributorId()
      }
      this.getList()
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.getList()
    },
    getOperationTypeName(type) {
      const typeMap = {
        1: '开锁',
        2: '关锁',
        3: '重启',
        4: '升级',
        5: 'IP设置',
        6: '定位',
        9: '开座舱锁',
        14: '语音播报'
      }
      return typeMap[type] || '其他'
    },
    getOperationTypeTag(type) {
      if (type === 1) return 'primary'
      if (type === 2) return 'warning'
      if (type === 3) return 'info'
      return ''
    }
  }
}
</script>

<style scoped>
.operation-record-container {
  padding: 0;
}

.box-card {
  border: none;
  box-shadow: none;
}

.search-area {
  padding: 16px;
  background: #f5f7fa;
  border-radius: 8px;
  margin-bottom: 16px;
}

.search-area .el-form-item {
  margin-bottom: 12px;
  margin-right: 16px;
}

.table-container {
  margin-top: 0;
}

.el-pagination {
  margin-top: 16px;
  padding: 0;
}
</style>
